import { useMemo } from 'react';
import PortalIdParser from 'PortalIdParser';
import UIList from 'UIComponents/list/UIList';
import { FOLDER_OBJECT_TYPE, FOLDER_PROPERTIES, UNFILED_ASSETS_ID } from 'framework-listing-lib/internal/Folders/constants/folders';
import useFetchRecentFolders from 'framework-listing-lib/internal/Folders/hooks/useFetchRecentFolders';
import useUnfiledAssetsName from 'framework-listing-lib/internal/Folders/hooks/useUnfiledAssetsName';
import useFetchFoldersById from 'framework-listing-lib/internal/Folders/hooks/useFetchFoldersById';
import FolderNavItem from './FolderNavItem';
import UnfiledAssetsNavItem from './UnfiledAssetsNavItem';
import FolderListSkeleton from './FolderListSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function RecentFolders({
  currentFolderId,
  onClickFolder,
  selectedAssetCount,
  selectedAssetFolderId
}) {
  const {
    recentFolders,
    loading: loadingRecentFolders
  } = useFetchRecentFolders();
  const {
    data,
    loading: loadingFolders
  } = useFetchFoldersById(recentFolders.map(recentFolder => recentFolder.id));
  const unfiledAssetName = useUnfiledAssetsName();
  const unfiledAssetNameFolder = useMemo(() => ({
    objectId: UNFILED_ASSETS_ID,
    objectTypeId: FOLDER_OBJECT_TYPE,
    portalId: PortalIdParser.get(),
    properties: {
      [FOLDER_PROPERTIES.name]: {
        value: unfiledAssetName
      }
    }
  }), [unfiledAssetName]);
  const unfiledAssetsNavItem = /*#__PURE__*/_jsx(UnfiledAssetsNavItem, {
    folder: unfiledAssetNameFolder,
    isSelected: currentFolderId === unfiledAssetNameFolder.objectId,
    onClick: () => onClickFolder(unfiledAssetNameFolder),
    openFoldersMap: {},
    selectedAssetCount: selectedAssetCount,
    selectedAssetFolderId: selectedAssetFolderId
  });
  if (loadingRecentFolders || loadingFolders) {
    return /*#__PURE__*/_jsx(FolderListSkeleton, {
      total: 10
    });
  }
  if (!data || data.length === 0) {
    return /*#__PURE__*/_jsx(UIList, {
      "data-test-id": "suggested-folders-empty-state",
      children: unfiledAssetsNavItem
    });
  }
  return /*#__PURE__*/_jsxs(UIList, {
    "data-test-id": "recent-folders-list",
    children: [recentFolders.some(recentFolder => recentFolder.id === UNFILED_ASSETS_ID) ? /*#__PURE__*/_jsx(_Fragment, {
      children: unfiledAssetsNavItem
    }) : null, recentFolders.filter(recentFolder => recentFolder.id !== UNFILED_ASSETS_ID).map(recentFolder => {
      const crmFolder = data.find(folder => folder.objectId === recentFolder.id);
      if (!crmFolder) {
        return null;
      }
      return /*#__PURE__*/_jsx(FolderNavItem, {
        folder: crmFolder,
        isSelected: currentFolderId === crmFolder.objectId,
        onClick: () => onClickFolder(crmFolder),
        openFoldersMap: {},
        selectedAssetCount: selectedAssetCount,
        selectedAssetFolderId: selectedAssetFolderId
      }, crmFolder.objectId);
    })]
  });
}